import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Process from "../components/Process";
import Testimonials from "../components/Testimonials";
import TrustedSlider from "../components/TrustedSlider";
import BlogSection from "../components/BlogSection";

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const targetId = location.state?.scrollTo;
    if (targetId) {
      const section = document.getElementById(targetId);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 80);
      }
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    // Fallback: Update meta tags directly
    document.title = "Digital Marketing Company in India | Hire Digital Marketing Experts";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "Looking for a digital marketing company in India? Hire expert digital marketing services for SEO, PPC, social media, and lead generation to grow your business.";
  }, []);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Company in India | Hire Digital Marketing Experts</title>
        <meta name="description" content="Looking for a digital marketing company in India? Hire expert digital marketing services for SEO, PPC, social media, and lead generation to grow your business." />
      </Helmet>
      <Hero />
      <About />
      <Services />
      <Process />
      <Testimonials />
      <TrustedSlider />
      <BlogSection />
    </>
  );
}

export default HomePage;
